import { z } from 'zod'

export const MEMBERSHIP_INVITES_ACCEPT_CONTRACT_VERSION = '1.0.0' as const

export const membershipInvitesAcceptResponseSchema = z.record(z.unknown())

export type MembershipInvitesAcceptResponse = z.infer<typeof membershipInvitesAcceptResponseSchema>
